/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import * as React from 'react';

import { MuiThemeProvider, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import Booking from './app/Booking';

import { window2config } from './cfg/config';

import CONFIG from './cfg/config';
import CookiesFooter from './app/common/CookiesFooter';
import themeCookies from './themesCookies';
import { store, Actions } from './appredux';
import { sendErrorLog } from './app/common/helpers';
import { UserData } from './api';
import OknoPrzerwa from './app/components/OknoPrzerwa';
import { Fab } from '@material-ui/core';
import * as M from '@material-ui/core';
import { Trans } from 'react-i18next';
import MapContainer from 'app/map_pszczoly/MapContainer';

/*
import Projekt  from './projekt2'
const test = true;
if (test) 
    return(<Projekt />)
else
*/

export const ThemeOrange = M.createTheme({
  palette: {
    primary: {
      main: "#e65100",
    },
    secondary: {
      main: "#3a87ad",
    },
  },
});

const styles = (theme: Theme) => ({
  root: {
    padding: "5px",
    minHeight: "98vh",
    //background: `url(${tloUrl})`,
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  }

});

//PM 2021-11-03
interface AppState {
  cookiesZaakceptowane: boolean,
  openMapa: boolean
}

class App extends React.Component<WithStyles<typeof styles>, AppState> {

  //PM 2021-11-03
  constructor(props: WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   

    //window.localStorage.setItem("userData", `{"zamOsobaId":"8","zamFirmaId":"1","zamOddzialId":"2","nazwisko":"SZYMEK","logo":"G&G050","telefon":"501417198","email":"szymonwawrzaszek@o2.pl","uprawnieniaPoziom":"1","firmaOpis":"VW-AUDI-SEAT G&G AUTO RZESZÓW","oddzialOpis":"SEAT - SERWIS","oddzialAdres":"LUBELSKA 50 C wejscie glowne","dostawaGodzMinuta":"1899-12-30 12:00:00","dostawaJakiDzien":"3","payweb":"1","timestamp":1652279301905}`)

    window.addEventListener('storage', async (event) => {
      if (event.key === "userData") {
        if (!window.localStorage.getItem("userData")) {
          window.localStorage.setItem("userData", event.newValue || "")
          await this.getDataFromLocalStorage();
        }
      }
    });

    
    const cookiesZaakceptowane = localStorage.getItem('cookies_zaakceptowane')

    this.state = {
      cookiesZaakceptowane: cookiesZaakceptowane ? true : false,
      openMapa: false
    }

    const title = document.getElementsByTagName("title")[0];

    let text = CONFIG.hotelID.split(" ").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1).toLowerCase()).join(" ")
    text = text.split("-").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1)).join("-")

    title.innerText = "Zamów (w) " + text
  }

  async componentDidMount() {
    await this.getDataFromLocalStorage();
    sendErrorLog( "1", "1", "start aplikacji")
    await store.dispatch(Actions.pageState.addFcmLogMessage("start aplikacji", 0))
  }

  getDataFromLocalStorage = async () => {
    let content = "";
    
    //bierzemy dane z localStorage
    if (window.localStorage.getItem("userData")) {
      //vscTest
      //alert('bierzemy dane z localStorage')
      content = window.localStorage.getItem("userData") || "";
      const parsedContent: UserData = JSON.parse(content);
      //vscTest
      //console.log(parsedContent)

      if(parsedContent){
        if(Number(parsedContent.timestamp) + 60*60*1000 > new Date().getTime()){
          await store.dispatch(Actions.pageState.setUserDataFromLocalStorage(parsedContent));
          await store.dispatch(Actions.pageState.setInitialValues({ address: parsedContent.oddzialAdres , phone: Number(parsedContent.telefon), NIP: "", Date: '', email: ''}));
        }  
      }

      //setTimeout(() => {
      //  localStorage.removeItem("userData")
      //}, 3000);
    }
  }

  closeMapa = () => {
    this.setState({openMapa: !this.state.openMapa})
  }

  //PM 2021-11-25
  //const tloUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/tlo.png`
  render() {
    const { classes } = this.props;
    const tloUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/tlo.png`
    /*  
        const isLoggedIn = true;
        if (!isLoggedIn) {
          return (
            <Switch>
              <Route path="/">
                <Redirect to="/login" />
              </Route>
            </Switch>
          );
        }
        if (location.pathname == '/login') {
          return <Redirect to="/" />;
        }
      
    */
    return (
      <React.Fragment>
        <div className={classes.root} style={{ background: `url(${tloUrl})` }}>
          {/*false? <AppBar position="static" elevation={0}>
            <Toolbar variant="dense" className={classes.toolbar}>
            <FlagIcons />
              <Typography className={classes.title} variant="h6" noWrap>
                <Trans>Room booking</Trans>
              </Typography>
              <div className={classes.grow} >
                {<BasketIcon  />}
              </div>
            </Toolbar>
    </AppBar>: null*/}

          {CONFIG.przerwa === "1" ? <OknoPrzerwa /> : this.state.openMapa ? <MapContainer /> : <Booking />}


          <div id="dialog_sms"></div>
          <div id="dialog"></div>
          <div id="thank_you_dialog"></div>
        </div>
        {this.state.cookiesZaakceptowane ? null :
          (
            <MuiThemeProvider theme={themeCookies}>
              <CookiesFooter />
            </MuiThemeProvider>
          )}



        {/* <MuiThemeProvider theme={ThemeOrange}>
          <Fab
            className="mapBack"
            style={{ fontSize: "14px" }}
            color="primary"
            //aria-label="dodaj"
            onClick={() => this.closeMapa()}
          >
            {this.state.openMapa ? "wróć" : "mapa"}
          </Fab>
        </MuiThemeProvider> */}

      </React.Fragment>
    );

  }
}

export default withStyles(styles)(App);
